import styled from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import '../Filter/index.js';
import { Filter } from '../Filter/Filter.js';

const NavbarFilter = styled(Filter) `
  min-width: 170px;

  input[type='text'] {
    background: white;
  }

  ${breakpoint('xs') `
    max-width: 300px;
  `}
`;

export { NavbarFilter };
